import { CityData, OfficeData } from "@/types";

export const getEntityIdPair = (entityType: string, city: CityData | null, ao: OfficeData | null) => {
    if (entityType === 'city' && city) {
      return { city_id: city.id };
    } else if (entityType === 'ao' && ao) {
      return { ao_id: ao.id };
    }
    return {};
};